// import { useEffect, useState } from 'react';
import MiniMainCard from '../MiniMainCard'

const MainCard = ({ MainTitle, SPOTHealthData }) => {
    // const [toggleState, setToggleState] = useState(true)
    // const [isDeviceHealth, setIsDeviceHealth] = useState(true);
    // const [healthData, setHealthData] = useState(SPOTHealthData);

    {/* useEffect(() => {
        // Assuming healthData is the object you provided
        // const healthDataLocal = toggleState ? SPOTHealthData : AgentHealthData;
        setHealthData(SPOTHealthData);

        if (SPOTHealthData) {
            const { lastPresence, heartBeat } = SPOTHealthData;
            let datePattern = /^(\d{2})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/;

            let heartBeatDateMatch = heartBeat.value.match(datePattern);
            let lastPresenceDateMatch = lastPresence.value.match(datePattern);

            // let heartBeatTimeStamp = 0
            // let lastPresenceDateTimeStamp = 0


            if (heartBeatDateMatch && lastPresenceDateMatch) {
                // heartBeatTimeStamp = new Date(`20${heartBeatDateMatch[3]}-${heartBeatDateMatch[2]}-${heartBeatDateMatch[1]}T${heartBeatDateMatch[4]}:${heartBeatDateMatch[5]}:00`).getTime();
                // lastPresenceDateTimeStamp = new Date(`20${lastPresenceDateMatch[3]}-${lastPresenceDateMatch[2]}-${lastPresenceDateMatch[1]}T${lastPresenceDateMatch[4]}:${lastPresenceDateMatch[5]}:00`).getTime();

            } else {
                // Invalid date format for heartBeat or lastPresence
            }

            // const currentTime = new Date().getTime();
            // const lastPresenceDiff = (currentTime - lastPresenceDateTimeStamp) / (1000 * 60 * 60 * 24);
            // const heartBeatDiff = (currentTime - heartBeatTimeStamp) / (1000 * 60 * 60 * 24);

            // Check if either lastPresence or heartBeat is older than two days (in milliseconds)
            // const isOlderThanTwoDays = lastPresenceDiff > 2 || heartBeatDiff > 2 || healthDataLocal.I2C.value === 'True';

            // Update the state based on the condition
            // setIsDeviceHealth(!isOlderThanTwoDays);
        } else {
            // setIsDeviceHealth(false);
        }
    }, [toggleState]); */}

    // const onToggleChange = () => {
    //     setToggleState(!toggleState);
    // };

    return (
        <>
            <div className=' w-full h-48 md:h-48 md:w-72 2xl:h-56 2xl:w-96 p-4 text-[12px] md:text-[12px] 2xl:text-[14px] bg-secondaryBg rounded-md border-2 border-dividerLines '>
                <div className='  flex justify-between items-center'>
                    <div className='  flex gap-2 2xl:gap-4 justify-between items-center'>
                        <span className='capitalize font-bold text-[14px] 2xl:text-base'>
                            {MainTitle}
                        </span>
                        {/* {healthData ?
                            <>
                                {
                                    isDeviceHealth ?
                                        <div className='relative flex justify-center items-center'>
                                            < div className='w-4 h-4 2xl:w-6 2xl:h-6 bg-alertSuccess opacity-30 rounded-full flex justify-center items-center'>
                                            </div>
                                            <div className=' absolute w-3 h-3 2xl:w-4 2xl:h-4 rounded-full bg-secondaryBg flex justify-center items-center'>
                                                <div className='w-2 h-2 2xl:w-3 2xl:h-3  rounded-full bg-alertSuccess'></div>
                                            </div>
                                        </div>
                                        :
                                        <div className='relative flex justify-center items-center'>
                                            <div className='w-4 h-4 2xl:w-6 2xl:h-6 bg-alertError opacity-30 rounded-full flex justify-center items-center'>
                                            </div>
                                            <div className=' absolute w-3 h-3 2xl:w-4 2xl:h-4 rounded-full bg-secondaryBg flex justify-center items-center'>
                                                <div className='w-2 h-2 2xl:w-3 2xl:h-3 rounded-full bg-alertError'></div>
                                            </div>
                                        </div>
                                }
                            </>
                            :
                            <></>
                        } */}
                    </div>
                    {/* <div className='relative flex justify-between items-center'>
                        <span className={` text-xs md:text-[9px] 2xl:text-[12px] font-bold ${toggleState ? 'text-placeholder ' : ' text-primaryText'}`}>Agent</span>
                        <label onClick={onToggleChange} className="relative flex justify-between items-center text-xl">
                            <input type="checkbox" checked={toggleState} readOnly className="absolute cursor-pointer left-1/2 -translate-x-1/2 w-full h-full peer appearance-none rounded-md" />
                            <span className=" 
                                cursor-pointer
                                w-6 h-4
                                flex items-center 
                                flex-shrink-0 ml-2 mr-2 p-1
                                bg-primaryText rounded-full
                                duration-300 ease-in-out 
                                peer-checked:bg-primaryText
                                after:w-2 after:h-2 
                                after:bg-alertSuccess 
                                after:rounded-full after:shadow-md after:duration-300 
                                peer-checked:after:translate-x-2 group-hover:after:translate-x-1">
                            </span>
                        </label>
                        <span className={`text-xs md:text-[9px] 2xl:text-[12px] font-bold ${toggleState ? 'text-primaryText ' : ' text-placeholder '}`}>SPOT</span>
                    </div> */}
                </div >
                <hr className=" my-2 h-[1px] border-t-0 bg-dividerLines " />
                <div className="flex flex-row  divide-x divide-dividerLines">
                    <MiniMainCard
                        miniCardData={SPOTHealthData}
                    />
                </div>
            </div >
        </>
    )
}

// Skip prop validation by setting propTypes to null
MainCard.propTypes = null;

export default MainCard